module.exports = __webpack_public_path__ + "img/business.954af2a3.svg";